import { render } from "./CreateResidenceView.vue?vue&type=template&id=e3203e8e&scoped=true"
import script from "./CreateResidenceView.vue?vue&type=script&lang=js"
export * from "./CreateResidenceView.vue?vue&type=script&lang=js"

import "./CreateResidenceView.vue?vue&type=style&index=0&id=e3203e8e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\WEB-SITE-DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3203e8e"]])

export default __exports__